import { createFileRoute } from '@tanstack/react-router';
import { Checkbox } from '@osd/ui/checkbox';
import { Field } from '@osd/ui/field';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/checkbox — live docs for the `Checkbox` primitive.
 */
export const Route = createFileRoute('/ui/_layout/checkbox')({
  component: CheckboxPage,
});

function CheckboxPage() {
  return (
    <Stack gap={6}>
      <Section
        title="Checkbox"
        hint="uncontrolled-friendly (name attr) or controlled (value + onChange)"
      >
        <Stack gap={3}>
          <Field label="Notifications">
            <Checkbox name="notif-email" label="Email" defaultChecked />
            <Checkbox name="notif-sms" label="SMS" />
          </Field>
          <Checkbox name="agree" label="I agree to the terms" />
        </Stack>
      </Section>

      <Section title="States" hint="disabled, with hint, with required">
        <Stack gap={3}>
          <Checkbox name="locked" label="Always-on (locked by admin)" defaultChecked disabled />
          <Checkbox
            name="opt-out"
            label="Opt out of analytics"
            hint="No personally identifiable data is collected."
          />
          <Checkbox name="accept" label="I accept the terms" required />
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Uncontrolled — name attr + label"
            hint="useForm() picks up values via the form element"
            language="tsx"
            code={`<Checkbox name="agree" label="I agree to the terms" />`}
          />

          <CodeBlock
            title="Default checked"
            language="tsx"
            code={`<Checkbox name="notif-email" label="Email" defaultChecked />`}
          />

          <CodeBlock
            title="Controlled"
            language="tsx"
            code={`const [agreed, setAgreed] = useState(false);
return (
  <Checkbox
    name="agree"
    label="I agree"
    checked={agreed}
    onChange={(e) => setAgreed(e.target.checked)}
  />
);`}
          />

          <CodeBlock
            title="Disabled + locked"
            language="tsx"
            code={`<Checkbox name="locked" label="Always-on" defaultChecked disabled />`}
          />

          <CodeBlock
            title="With hint"
            hint="hint renders below the label in muted style"
            language="tsx"
            code={`<Checkbox
  name="opt-out"
  label="Opt out of analytics"
  hint="No personally identifiable data is collected."
/>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
